// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__TMGJQ","check":"Switch_check__zeTgi","borderCover":"Switch_borderCover__6PluS","slider":"Switch_slider__TzsPE","label":"Switch_label__Yd2VN"};